import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useMusicPlayer } from "@/context/MusicPlayerContext";
import { useI18n } from "@/context/I18n";
import TrackRow from "@/components/music/TrackRow";
import { Loader2, Play, Heart } from "lucide-react";

export default function LikedSongs() {
  const [tracks, setTracks] = useState(null);
  const { playQueue } = useMusicPlayer();
  const { t } = useI18n();

  const load = () => api.get("/music/favorites").then((r) => setTracks(r.data.tracks)).catch(() => setTracks([]));
  useEffect(() => {
    load();
    const h = () => load();
    window.addEventListener("likes-changed", h);
    return () => window.removeEventListener("likes-changed", h);
  }, []);

  return (
    <div>
      <div className="p-4 md:p-8 pb-6 bg-gradient-to-b from-[#FF2A4D]/25 to-transparent flex items-end gap-6">
        <div className="w-40 h-40 rounded-lg bg-gradient-to-br from-[#FF2A4D] to-fuchsia-700 flex items-center justify-center shadow-2xl shrink-0">
          <Heart className="w-16 h-16 text-white" fill="white" />
        </div>
        <div>
          <p className="text-xs uppercase tracking-wider font-bold">{t("playlist")}</p>
          <h1 className="font-display text-4xl md:text-5xl font-black tracking-tighter mt-2">{t("liked_songs")}</h1>
          <p className="text-zinc-300 mt-3 text-sm">{tracks ? tracks.length : 0} {t("tracks")}</p>
        </div>
      </div>
      <div className="px-8 py-4">
        <button data-testid="liked-play-all" onClick={() => tracks && tracks.length && playQueue(tracks, 0)}
          className="w-14 h-14 rounded-full bg-[#FF2A4D] hover:bg-[#E61C3D] hover:scale-105 flex items-center justify-center transition-all">
          <Play className="w-6 h-6 text-white ml-1" fill="white" />
        </button>
      </div>
      <div className="px-5 pb-6">
        {tracks === null ? <div className="py-10 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-zinc-500" /></div>
          : tracks.length === 0 ? <p className="text-zinc-500 text-sm px-3 py-8 text-center">{t("no_liked")}</p>
          : tracks.map((tr, i) => <TrackRow key={tr.id} track={tr} index={i} tracks={tracks} showAdd={false} />)}
      </div>
    </div>
  );
}
